import { render, staticRenderFns } from "./FilterSchoolSearch.vue?vue&type=template&id=98947964&scoped=true&"
import script from "./FilterSchoolSearch.vue?vue&type=script&lang=ts&"
export * from "./FilterSchoolSearch.vue?vue&type=script&lang=ts&"
import style0 from "./FilterSchoolSearch.vue?vue&type=style&index=0&id=98947964&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98947964",
  null
  
)

export default component.exports